import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { getTranslation, getTranslationPop, getTranslationParams } from './services/Base/TranslationUtils';
import { getTranslationI, getTranslationI_G, getTranslationI_YO, getTranslationI_YO_G } from './services/Base/TranslationUtilsIframe';
import SpinnerContainer from './components/ui/SpinnerContainer.vue';
import ResearchLink from './components/ui/ResearchLink.vue';
import '../src/components/directives';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import BootstrapVue from 'bootstrap-vue';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

// leaflet css
import 'leaflet/dist/leaflet.css'

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(VueSweetalert2);
Vue.component("SpinnerContainer", SpinnerContainer)
Vue.component("ResearchLink", ResearchLink)

// Translate
Vue.prototype.$t = function (key) {
  return getTranslation(store, key);
};

Vue.prototype.$tPop = function (key, varibale, value = '') {
  return getTranslationPop(store, key, varibale, value);
};

Vue.prototype.$tParams = function (key,  params = [], values = [], text = '') {
  return getTranslationParams(store, key, params, values, text);
};

// Translate Iframe
Vue.prototype.$tI= function (key) {
  return getTranslationI(store, key);
};

Vue.prototype.$tI_G = function (key) {
  return getTranslationI_G(store, key);
};

Vue.prototype.$tI_YO = function (key) {
  return getTranslationI_YO(store, key);
};

Vue.prototype.$tI_YO_G = function (key) {
  return getTranslationI_YO_G(store, key);
};

// Global error handler
// Vue.config.errorHandler = (err, vm, info) => {
//   console.error('Global Error Handler:', err, info);
//   console.log(err)
// };

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#id-app');
